// extracted by mini-css-extract-plugin
module.exports = {"root":"background_root__3yKud","bgTop":"background_bgTop__2GZO4","bgBottom":"background_bgBottom__1kWff"};